import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CButton,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CPagination,
	CPaginationItem,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CFormTextarea,
	CBadge,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { Calendar, dateFnsLocalizer, Views } from 'react-big-calendar';
import {
  format,
  parse,
  startOfWeek, 
  endOfWeek,
  getDay,
  addWeeks,
  addDays,
  addHours,
  addMonths,
  subMonths,
  differenceInDays,
} from 'date-fns';
import { id } from 'date-fns/locale'; // Indonesian locale
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyDialoglookup,
	MyDialogview,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'
import 'react-big-calendar/lib/css/react-big-calendar.css';

const pjson 	= require('../../package.json');
const locales 	= {
  'id-ID': id, // Register Indonesian locale
};
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: (date) => startOfWeek(date, { weekStartsOn: 1 }), // Week starts Monday
  endOfWeek: (date) => endOfWeek(date, { weekStartsOn: 1 }), // Week starts Monday
  getDay,
  locales,
});
const Agendaklinik	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 25) : 100;
	//const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uISUpdateallow			= (uTokenObj.userhak==="FREEROLE" || uTokenObj.userhak==="ADMIN" 
				|| uTokenObj.userhak==="ENTRI");
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  			= useSelector(state => state.gInitHeaderAction);

	//--VIEWS_VARS--/
	const uSavedview					= localStorage.getItem("initKalenderview") || "BULAN";
	const uCabangIDinit					= parseInt(uTokenObj.user_cabangid)||0;
	const uDatacabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]")
	//const [uJmlData,setJmlData]			= React.useState(0);
	//const [uPageActive,setPageActive]	= React.useState(1);
	const [uTglLastload,setTglLastload]	= React.useState();
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uCalendarObj, setCalendarObj] = React.useState({});//->currentDate,currentView,agendaRange
	const {currentDate, currentView, calendarLabel, agendaRange } = uCalendarObj;
	//--END VIEWS_VARS--/

	/*//--INIT_SELECTED_BEFORE--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--END INIT_SELECTED_BEFORE--*/

	//--DLGLOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj]		= React.useState({});
	//--END DLGLOOKUP--/

	//--DLGFORM--/
	const [uDatadokterArr,setDatadokterArr]		= React.useState([]);
	const [uISDlgformshow,setDlgformshow]		= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]	= React.useState({});
	const uColoreventArr	= [
			{ code:"#ff3d00", nama:"Merah"},
			{ code:"#f1c40f", nama:"Kuning"},
			{ code:"#2e86c1", nama:"Biru"},
			{ code:"#52be80", nama:"Hijau"},
			{ code:"#bb8fce", nama:"Purple"},
			{ code:"#c6cf5f", nama:"Lime"},
		];
	//--END DLGFORM--/

	//--DLGVIEW--/
	const [uISDlgviewshow,setDlgviewshow]		= React.useState(false);
	const [uDlgviewdataObj,setDlgviewdataObj]	= React.useState({});
	//--END DLGVIEW--/

	//--DOM_VARS--/
	const uScreenwidth				= window.outerWidth;

	const uISCellphone				= uScreenwidth <= 425;
	const uISTablet					= uScreenwidth > 425 && uScreenwidth <= 768;
	const uISDesktop				= uScreenwidth > 768;

	const uMaxcardheight			= uISDesktop ? window.innerHeight - 160 : window.innerHeight - 170;
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikTambahdata = (_DATAEVENT) => {
		//console.log("(Agendaklinik - hdlKlikTambahdata) _DATAEVENT",_DATAEVENT);
		const vTglnowDT		= new Date();
		const vTglstartDT	= _DATAEVENT?.start || currentDate;
		const vTglakhirDT	= _DATAEVENT ? addDays(_DATAEVENT?.end, -1) : currentDate;

		if(_DATAEVENT) {
			const vISChangetime = 
				vTglstartDT.getHours() === 0 
				&& vTglstartDT.getMinutes() === 0 
				&& vTglstartDT.getSeconds() === 0
				&& vTglakhirDT.getHours() === 0 
				&& vTglakhirDT.getMinutes() === 0 
				&& vTglakhirDT.getSeconds() === 0;

			if(vISChangetime) {
				vTglstartDT.setHours(vTglnowDT.getHours(), vTglnowDT.getMinutes(), 0);
				vTglakhirDT.setHours(vTglnowDT.getHours(), vTglnowDT.getMinutes(), 0);
			}
		}

		if(vTglakhirDT < vTglstartDT) {
			vTglakhirDT.setDate(vTglstartDT.getDate());
			vTglakhirDT.setMonth(vTglstartDT.getMonth());
			vTglakhirDT.setFullYear(vTglstartDT.getFullYear());
		}

		setCalendarObj({...uCalendarObj,
			currentDate: vTglstartDT,
		});

		const vColorIdx = Math.floor(Math.random() * uColoreventArr.length);
		const vDokterObj = uTokenObj.userhak==="DOKTER"
			? {id_dokter: uTokenObj.user_dokterid,caption_dokter:uTokenObj.usercaption }
			: {}
		setDlgformdataObj({
			dlg_header:"Tambah Agenda Klinik",
			id_cabang: parseInt(uHeaderActionObj.cabang_id) || uCabangIDinit, 
			tgl_awal: UFunc.DbDate(vTglstartDT),
			jam_awal: UFunc.JamMenit(vTglstartDT),
			tgl_akhir: UFunc.DbDate(vTglakhirDT),
			jam_akhir: UFunc.JamMenit(vTglakhirDT),
			status_allday: "TIDAK",
			status_agenda: "WARNING",
			color: uColoreventArr[vColorIdx].code||"#ff3d00",
			...vDokterObj,
		})
		setDlgformshow(true);
	}
	const hdlKlikViewdata = (_DATAEVENT) => {
		if(!_DATAEVENT) return;

		//console.log("(Agendaklinik - hdlKlikViewdata) _DATAEVENT",_DATAEVENT);
		const vHeadertitle	= (_DATAEVENT?.title_db||_DATAEVENT?.title).length > 30
			? (_DATAEVENT?.title_db||_DATAEVENT?.title).substring(0,30).trim()+"..."
			: (_DATAEVENT?.title_db||_DATAEVENT?.title);

		setDlgviewdataObj({
			dlg_header: vHeadertitle,
			title: _DATAEVENT?.title_db || _DATAEVENT?.title,
			tabelid: parseInt(_DATAEVENT?.id) || 0,
			id_cabang: parseInt(_DATAEVENT?.id_cabang) || uCabangIDinit, 
			id_dokter: parseInt(_DATAEVENT?.id_dokter)||0,
			caption_dokter: _DATAEVENT?.caption_dokter,
			id_pasien: parseInt(_DATAEVENT?.id_pasien) || 0,
			tgl_awal: UFunc.DbDate(_DATAEVENT?.start),
			jam_awal: UFunc.JamMenit(_DATAEVENT?.start),
			tgl_akhir: UFunc.DbDate(_DATAEVENT?.end),
			jam_akhir: UFunc.JamMenit(_DATAEVENT?.end),
			status_allday:_DATAEVENT?.allDay ? "YA" : "TIDAK",
			status_agenda: _DATAEVENT?.status_agenda,
			color: _DATAEVENT?.color,
			deskripsi: _DATAEVENT?.desc,
			tgl_input: _DATAEVENT?.tgl_input,
			userinput: _DATAEVENT?.userinput,
		});
		setDlgviewshow(true);
	}
	const hdlKlikEdit = () => {
		if(!uISDlgviewshow) return;

		setDlgformdataObj({...uDlgviewdataObj,
			dlg_header: "Edit Data: "+(uDlgviewdataObj.dlg_header||"").toUpperCase(),
		});

		setDlgviewshow(false);

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			setDlgformshow(true);
		},50)
	}
	const hdlKlikHapus = async() => {
		if(!uISDlgviewshow) return;

		if(await Konfirm(
			"<p class='fst-italic'>"+
				"<b>Agenda '"+uDlgviewdataObj.title.toUpperCase()+"' Akan Dihapus</b>.."+
				"<small class='d-block mx-2'>"+uBahasaObj.petunjuk_hapus+"</small>"+
			"</p>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) apiProseshapus();
	}
	const hdlKlikDokterlookup = () => {
		const vDatalookupArr = uDatadokterArr.map(vItems =>{ 
			return {id: vItems.id,caption:vItems.dokter_caption} 
		})

		setDlglookupObj({...uDlglookupObj,
			dlg_header: (uBahasaObj.word_lookup||"Lookup")+": "+(uBahasaObj.caption_datadokter||"Data Dokter"),
			dlg_input: "",
			data_arr: vDatalookupArr,
		});

		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return

		setDlglookupshow(false);
		const vArridx 	= UFunc.getObjectIndeks(uDatadokterArr,_IDITEM)

		setDlgformdataObj({...uDlgformdataObj,
			caption_dokter: (uDatadokterArr[vArridx].dokter_caption||""),
			id_dokter: (uDatadokterArr[vArridx].id||"0"),
		})

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout)

			const vElfocus = document.getElementById("inptglawal");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350)
	}
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI--/
		let vElfocus = document.getElementById("inptitle");
		if((uDlgformdataObj.title || "").trim() === "") {
			vElfocus && vElfocus.focus();
			showToast("Title Agenda Harus Diisi !");
			return;
		}

		vElfocus = document.getElementById("inpdoktercaption");
		if((uDlgformdataObj.caption_dokter||"").trim() !== "") 
			if((parseInt(uDlgformdataObj.id_dokter)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("Dokter Harus Dipilih Terlebih Dahulu !");
				return;
			}

		vElfocus = document.getElementById("inptglawal");
		if(uDlgformdataObj.tgl_awal === "") {
			vElfocus && vElfocus.focus();
			showToast("Tgl Awal Tidak Valid !");
			return;
		}
		vElfocus = document.getElementById("inpjamawal");
		if(uDlgformdataObj.jam_awal === "") {
			vElfocus && vElfocus.focus();
			showToast("JAM Awal Tidak Valid !");
			return;
		}
		vElfocus = document.getElementById("inpjamakhir");
		if(uDlgformdataObj.jam_akhir === "") {
			vElfocus && vElfocus.focus();
			showToast("JAM Akhir Tidak Valid !");
			return;
		}
		vElfocus = document.getElementById("inptglakhir");
		if(uDlgformdataObj.tgl_akhir === "") {
			vElfocus && vElfocus.focus();
			showToast("Tgl Akhir Tidak Valid !");
			return;
		}

		const vJamakhir			= uDlgformdataObj.status_allday==="YA" ? uDlgformdataObj.jam_awal : uDlgformdataObj.jam_akhir;
		const vTanggalawalDT 	= UFunc.toDatetime(uDlgformdataObj.tgl_awal+" "+uDlgformdataObj.jam_awal+":00");
		const vTanggalakhirDT 	= UFunc.toDatetime(uDlgformdataObj.tgl_akhir+" "+vJamakhir+":00");

		const vTodayDT			= UFunc.toDatetime(UFunc.DbDate()+" 00:00:00");

		vElfocus = document.getElementById("inptglawal");
		if((parseInt(uDlgformdataObj.tabelid)||0) <= 0)
			if(vTanggalawalDT.valueOf() < vTodayDT.valueOf()) {
				vElfocus && vElfocus.focus();
				showToast("Tgl Awal Sudah Terlewati !");
				return;
			}

		if(vTanggalawalDT.valueOf() > vTanggalakhirDT.valueOf()) {
			vElfocus && vElfocus.focus();
			if(UFunc.DbDate(vTanggalawalDT) === UFunc.DbDate(vTanggalakhirDT)) 
				showToast("Jam Awal Melebihi Jam Akhir !");
			else
				showToast("TANGGAL Awal Melebihi TANGGAL Akhir !");
			return;
		}
		//--END VALIDASI--/

		apiProsessimpan();
	}
	//--END HANDEL--/

	//--INIT_FUNC--/
	const formatCalendarLabel = (date, view, rangeAgenda) => {
		const options = { 
			month: 'long', 
			year: 'numeric', 
			locale: 'id-ID' 
		};

		switch(view) {
			case 'month':
				return new Date(date).toLocaleDateString('id-ID', { 
					month: 'long', 
					year: 'numeric' 
				});
			case 'week':
				const start = startOfWeek(new Date(date), { weekStartsOn: 1 });
				const end = endOfWeek(new Date(date), { weekStartsOn: 1 });

				return `${start.toLocaleDateString('id-ID', { 
					day: 'numeric', 
					month: 'short'
				})} - ${end.toLocaleDateString('id-ID', {
					day: 'numeric',
					month: end.getMonth() !== start.getMonth() ? 'short' : undefined,
					year: end.getFullYear() !== start.getFullYear() ? 'numeric' : undefined
				})}`;

			case 'day':
				return new Date(date).toLocaleDateString('id-ID', { 
					weekday: 'short',
					day: 'numeric',
					month: 'short',
					year: 'numeric'
				});

			case 'agenda':
				return rangeAgenda 
					? `${format(rangeAgenda.start, 'dd/MM/yyyy')} – ${format(rangeAgenda.end, 'dd/MM/yyyy')}`
					: format(new Date(date), 'MMMM yyyy', { locale: id });
			default:
				return new Date(date).toLocaleDateString('id-ID');
		}
	}
	const initNavigation = (_JENISVIEW) => {
		_JENISVIEW		= _JENISVIEW || "TODAY";

		let vValueview;
		let vAgendarange	= undefined;
		const current 		= new Date(currentDate);

		switch(_JENISVIEW) {
			case "PREV":
				if (currentView === 'month') {
					vValueview = addMonths(current, -1);
				} else if (currentView === 'week') {
					vValueview = addWeeks(current, -1);
				} else if (currentView === 'day') {
					vValueview = addDays(current, -1);
				} else { // Agenda view
					// Move back by the current agenda range duration
					const rangeDuration = differenceInDays(agendaRange.end, agendaRange.start);
					vValueview = addMonths(current, -1);
					vAgendarange = {
						start: vValueview,
						end: addMonths(new Date(vValueview), 1) // Or your actual agenda range
					}
				}
				break;
			case "NEXT":
				if (currentView === 'month') {
					vValueview = addMonths(current, 1);
				} else if (currentView === 'week') {
					vValueview = addWeeks(current, 1);
				} else if (currentView === 'day') {
					vValueview = addDays(current, 1);
				} else { // Agenda view
					// Move forward by the current agenda range duration
					const rangeDuration = differenceInDays(agendaRange.end, agendaRange.start);
					vValueview = addMonths(current, 1);
					vAgendarange = {
						start: vValueview,
						end: addMonths(new Date(vValueview), 1) // Or your actual agenda range
					}
				}
				break;
			default: 
				vValueview = new Date();
				if (currentView === 'agenda') {
					vAgendarange = {
						start: vValueview,
						end: addMonths(new Date(vValueview), 1) // Or your actual agenda range
					}
				}
		}

		setCalendarObj({...uCalendarObj,currentDate:vValueview,agendaRange:vAgendarange});
	}
	//--END INIT_FUNC--/

	//--CONTENT_FUNC--/
	const contentMain = () => {
		if (uHtml500msg) return "";

		return (
		<>
		<div className="d-none">{(uTglLastload || new Date()).toString()}</div>
		<div className="h-100">
		<Calendar
			localizer={localizer}
			events={uDatamainArr}
			startAccessor="start"
			endAccessor="end"
			culture="id-ID"
			style={{}}
			components={{
				toolbar: ()=>null,
			}}
			messages={{
				date: "Tanggal",
				time: "Jam",
				event: "Agenda",
				noEventsInRange: (() => { return (<div className="mt-5 text-center classpetunjuk">Tidak ada Agenda dalam rentang ini.</div>)})()
			}}
			onSelectEvent={(event) => { hdlKlikViewdata(event) }}
			onSelectSlot={(slotInfo) => {
				hdlKlikTambahdata(slotInfo);
			}}
			eventPropGetter={(event) => ({
				style: { 
					backgroundColor: event.color, 
					fontSize: currentView === 'month' ? '14px' 
						: (currentView === 'agenda' ? '20px' : 'inherit'),
					lineHeight: '1.2',
					fontFamily: "Calibri, sans-serif",
				}
			})}
			onDrillDown={(date) => {
				setCalendarObj({...uCalendarObj,
					currentDate: date,
					currentView: "day",
				});
				uDispatch({type: "set", Kalenderview: "HARI"});
			}}
			date={currentDate}
			view={currentView}
			onNavigate={()=>{}}
			onView={()=>{}}
			selectable/>
			</div>
		</>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		const vCabangidvalue= uDlgformdataObj.id_cabang;
		const vCabangidx	= UFunc.getObjectIndeks(uDatacabangArr,vCabangidvalue);

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilBuilding" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Cabang</span>
			</CCol>
			<CCol className="text-start">
				<b className="text-primary">
				{(uDatacabangArr[vCabangidx]||{}).cabang_nama}
				</b>
			</CCol>
		</CRow>

		<div className="classborderbottom my-3"/>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilHeader" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Title</span>
			</CCol>
			<CCol className="text-start">
				<CFormInput size="sm" maxLength={100}
					className="text-capitalize"
					value={uDlgformdataObj.title||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,title:e.target.value})}
					id="inptitle"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilContact" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Dokter</span>
			</CCol>
			<CCol className="text-start">
				<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					value={uDlgformdataObj.caption_dokter||""}
					onClick={()=>{if(!uISUpdateallow) return; hdlKlikDokterlookup()}}
					placeholder="--Pilih Nama Dokter"
					id="inpdoktercaption"/>
				{uISUpdateallow && (
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikDokterlookup()}
					id="btndokterlookup">
					<CIcon icon="cilSearch"/>
				</CButton>
				)}
				</CInputGroup>

				<div className="classpetunjuk">
					*) Kosongi Jika merupakan Acara Klinik (Mis: Klinik Libur).
				</div>
			</CCol>
		</CRow>

		<div className="classborderbottom my-3"/>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilClock" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Tanggal</span>
			</CCol>

			{uDlgformdataObj.status_allday!=="YA" ? (
			<CCol className="d-lg-flex justify-content-between align-items-center">
				{uISDesktop ? (
				<>
				<CInputGroup size="sm">
				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_awal}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_awal:e.target.value})}
					style={{minWidth:90,width:"60%"}}
					id="inptglawal"/>
				&nbsp;
				<CFormInput size="sm" type="time"
					value={uDlgformdataObj.jam_awal}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,jam_awal:e.target.value})}
					style={{minWidth:50,width:"38%"}}
					id="inpjamawal"/>
				</CInputGroup>

				<small className="mx-1 fw-bolder">s.d.</small>

				<CInputGroup className="" size="sm">
				<CFormInput size="sm" type="time"
					value={uDlgformdataObj.jam_akhir}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,jam_akhir:e.target.value})}
					style={{minWidth:50,width:"38%"}}
					id="inpjamakhir"/>

				&nbsp;

				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_akhir}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_akhir:e.target.value})}
					style={{minWidth:90,width:"60%"}}
					id="inptglakhir"/>
				</CInputGroup>
				</>
				) : (
				<>
				<CInputGroup size="sm">
				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_awal}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_awal:e.target.value})}
					style={{minWidth:90,width:"60%"}}
					id="inptglawal"/>
				&nbsp;
				<CFormInput size="sm" type="time"
					value={uDlgformdataObj.jam_awal}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,jam_awal:e.target.value})}
					style={{minWidth:50,width:"38%"}}
					id="inpjamawal"/>
				</CInputGroup>

				<CInputGroup className="mt-1" size="sm">
				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_akhir}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_akhir:e.target.value})}
					style={{minWidth:90,width:"60%"}}
					id="inptglakhir"/>

				&nbsp;

				<CFormInput size="sm" type="time"
					value={uDlgformdataObj.jam_akhir}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,jam_akhir:e.target.value})}
					style={{minWidth:50,width:"38%"}}
					id="inpjamakhir"/>
				</CInputGroup>
				</>
				)}
			</CCol>
			) : (
			<CCol xs="11" lg="7">
				{uISDesktop ? (
				<CInputGroup size="sm">
				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_awal}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_awal:e.target.value})}
					id="inptglawal"/>

				<small className="mx-1 fw-bolder">s.d.</small>

				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_akhir}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_akhir:e.target.value})}
					id="inptglakhir"/>
				</CInputGroup>
				) : (
				<>
				<CFormInput size="sm" type="date"
					value={uDlgformdataObj.tgl_awal}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_awal:e.target.value})}
					id="inptglawal"/>

				<CFormInput size="sm" type="date" className="mt-1"
					value={uDlgformdataObj.tgl_akhir}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,tgl_akhir:e.target.value})}
					id="inptglakhir"/>
				</>
				)}
			</CCol>
			)}
		</CRow>

		<CRow className="my-2 mb-3">
			<CCol xs="1" lg="3" className="px-2">&nbsp;</CCol>
			<CCol className="text-start">
			<input type="checkbox"
				value="YA"
				className="me-1"
				checked={uDlgformdataObj.status_allday==="YA"}
				onChange={()=>setDlgformdataObj({...uDlgformdataObj,
					status_allday:(uDlgformdataObj.status_allday==="YA"?"TIDAK":"YA")})}
				id="inpallday"/>
			<label className="classcursorpointer text-info" htmlFor="inpallday">
				<small>All Day (Seharian)</small>
			</label>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilStorage" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Status Agenda</span>
			</CCol>
			<CCol className="text-start">
				<CFormSelect size="sm"
					value={uDlgformdataObj.status_agenda}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,status_agenda:e.target.value})}
					style={{width:!uISDesktop ? "" : "50%"}}
					id="inpstatusagenda">
				<option value="WARNING">REMINDER</option>
				<option value="CLOSED">LIBUR (CUTI)</option>
				</CFormSelect>

				<div className="classpetunjuk">
					*) Jika LIBUR, Tanggal/Jam Tersebut Akan terblokir saat Input RESERVASI PASIEN.
				</div>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilColorPalette" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Pilih Warna</span>
			</CCol>
			<CCol className="text-start">
				<CDropdown>
					<CDropdownToggle color="transparent" className="p-0" caret={true}>
						<CIcon className="classikonbox" style={{backgroundColor:uDlgformdataObj.color}} height={25}/>
					</CDropdownToggle>

					<CDropdownMenu>
					{uColoreventArr.map((vItems,vKeys)=>{
						return (
						<CDropdownItem key={vKeys} className="px-1 classcursorpointer" onClick={()=>setDlgformdataObj({...uDlgformdataObj,color:vItems.code})}>
						<CIcon icon={uDlgformdataObj.color===vItems.code?"cilCheckAlt":""} className="text-white classikonbox me-2 align-middle" style={{backgroundColor:vItems.code}} height={25}/>{vItems.nama}
						</CDropdownItem>
						)
					})}
					</CDropdownMenu>
				</CDropdown>
			</CCol>
		</CRow>

		<div className="classborderbottom my-3"/>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilNotes" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">Catatan</span>
			</CCol>
			<CCol className="text-start">
				<CFormTextarea size="sm"
					rows={3}
					value={UFunc.br2nl(uDlgformdataObj.deskripsi||"")}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,deskripsi:UFunc.nl2br(e.target.value)})}
					onKeyDown={(e)=>{
						if(e.keyCode!==13) return;
						if(isMobile) return;
						if(e.shiftKey) return;
						UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					}
					id="inpcatatan"/>

				{(!isMobile) && (
				<div className="classpetunjuk">
					*) {uBahasaObj.petunjuk_textarea || "Ganti Baris Tekan [SHIFT] + [ENTER]"}
				</div>
				)}
			</CCol>
		</CRow>

		{(parseInt(uDlgformdataObj.tabelid)||0) <= 0 && (
		<>
		<div className="classborderbottom my-3"/>

		<CRow className="my-2">
			<CCol xs="1" lg="3" className="px-2">
				<span className="d-lg-none">
				<CIcon icon="cilUser" className="classikonbox bg-info text-white mx-0" height={25}/>
				</span>
				<span className="d-none d-lg-block">User Input</span>
			</CCol>
			<CCol className="text-start">
				<big className="fw-bolder">[{uTokenObj.usercaption}]</big>
			</CCol>
		</CRow>
		</>
		)}
		</CForm>
		)//>
	}
	const contentDlgview = () => {
		if(!uISDlgviewshow) return (<></>)//>

		const vCabangidvalue= uDlgviewdataObj.id_cabang;
		const vCabangidx	= UFunc.getObjectIndeks(uDatacabangArr,vCabangidvalue);

		const vTglnowDT 	= UFunc.toDate(UFunc.DbDate());
		const vTglakhirDT 	= UFunc.toDate(uDlgviewdataObj.tgl_akhir);

		return(
		<>
		<div className="d-none">{(vTglakhirDT.valueOf())}</div>

		<div className="d-flex justify-content-between">
			<CIcon className="classikonbox" style={{backgroundColor:uDlgviewdataObj.color}} height={25}/>

			{uDlgviewdataObj.status_agenda !== "RESERVASI" ? (
			<>
				{(uISUpdateallow 
					|| (uTokenObj.userhak==="DOKTER" 
						&& (parseInt(uTokenObj.user_dokterid)||0) === (parseInt(uDlgviewdataObj.id_dokter)||0)
						)
				) && (
				<div>
				<CTooltip content="--Edit Agenda" className="d-none d-lg-block">
				<CLink onClick={()=>hdlKlikEdit()} className="classcursorpointer classikontabel classikonedit"/>
				</CTooltip>

				<CTooltip content="--Hapus Agenda" className="d-none d-lg-block">
				<CLink onClick={()=>hdlKlikHapus()} className="classcursorpointer classikontabel classikonhapus"/>
				</CTooltip>
				</div>
				)}
			</>
			) : (
			<>
				{(uISUpdateallow && vTglakhirDT.valueOf() >= vTglnowDT.valueOf()) && (
				<CTooltip content="--Edit via Reservasi" className="d-none d-lg-block">
				<CLink onClick={()=>uNavigate("/subpasien/pasien/daftarantri/"+uDlgviewdataObj.id_pasien)} className="classcursorpointer classikontabel classikonedit"/>
				</CTooltip>
				)}
			</>
			)}
		</div>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilBuilding" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start fw-bolder">
				{(uDatacabangArr[vCabangidx]||{}).cabang_nama || "cabang_nama"}
			</CCol>
		</CRow>

		{(parseInt(uDlgviewdataObj.id_dokter)||0) > 0 && (
		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilContact" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start fw-bolder">
				{uDlgviewdataObj.caption_dokter || "caption_dokter"}
			</CCol>
		</CRow>
		)}

		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilClock" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start">
				<b>{UFunc.HariAngka(uDlgviewdataObj.tgl_awal)}</b>
				
				{uDlgviewdataObj.status_allday!=="YA" && (
				<>
					<span className="ms-1"/>
					<b>{uDlgviewdataObj.jam_awal}</b>
				</>
				)}

				{(uDlgviewdataObj.status_allday!=="YA"
					|| uDlgviewdataObj.tgl_awal !== uDlgviewdataObj.tgl_akhir
				) && (
				<span className="mx-1">-</span>
				)}
				
				{uDlgviewdataObj.tgl_awal !== uDlgviewdataObj.tgl_akhir && (
					<>
					<b>{UFunc.HariAngka(uDlgviewdataObj.tgl_akhir)}</b>
					</>
				)}

				{uDlgviewdataObj.status_allday!=="YA" && (
				<>
					<span className="ms-1"/>
					<b>{uDlgviewdataObj.jam_akhir}</b>
				</>
				)}
			</CCol>
		</CRow>

		<CRow className="my-0 mb-3 mx-0">
			<CCol xs="1" className="px-2">&nbsp;</CCol>
			<CCol className="text-start classfontsmaller">
			{uDlgviewdataObj.status_allday==="YA" ? (
				<CIcon icon="cilCheckCircle" className="me-1 text-info align-middle" height={20}/>
			) : (
				<CIcon icon="cilXCircle" className="me-1 text-danger align-middle" height={20}/>
			)}
			<small>All Day (Seharian)</small>
			</CCol>
		</CRow>

		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilStorage" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start">
				{uDlgviewdataObj.status_agenda!=="CLOSED" ? "REMINDER \/ RESERVASI" : "LIBUR \/ CUTI"}
			</CCol>
		</CRow>

		{(uDlgviewdataObj.deskripsi||"").trim() !== "" && (
		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilNotes" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start fst-italic">
				{UFunc.nl2br(uDlgviewdataObj.deskripsi||"-")}
			</CCol>
		</CRow>
		)}

		<CRow className="my-2 mx-0">
			<CCol xs="1" className="px-1 text-center">
				<CIcon icon="cilUser" className="border rounded p-1 bg-info text-white" height={28}/>
			</CCol>
			<CCol className="text-start text-danger classfontsmaller">
				<>[
				{UFunc.WaktuAngka(uDlgviewdataObj.tgl_input)}
				<span className="mx-1">&middot;</span>
				{uDlgviewdataObj.userinput || "Undf"}
				]</>
			</CCol>
		</CRow>

		</>
		)//>
	}
	//--END CONTENT_FUNC--/

	//--API--/
	const apiLoaddokter = () => {
		setDatadokterArr([]);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Daftarantri - apiLoadawal) LEWAT ");
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_dokter/ld_dokterlookup";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){ setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setDatadokterArr(JSON.parse(output_string.datadokter||"[]"))
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Agendaklinik - apiLoaddokter) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				prosesExpired(); return;
			}
			apiLoaddata();
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Agendaklinik - apiLoaddokter) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "));
			apiLoaddata();
		});
	}
	const apiLoaddata = () => {
		const vCabangidvalue = parseInt(uHeaderActionObj.cabang_id) || uCabangIDinit;
		setHtml500msg();
		setDatamainArr([]);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Agendaklinik - apiLoaddata) currentDate : "+currentDate);
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
			setTglLastload(currentDate);

			setDatamainArr([
			{"id": 1,"title": "Rapat Tim Marketing","start": new Date(2025, 5, 18, 12, 0),"end": new Date(2025, 5, 18, 13, 0),"color": "#4285F4"},
  			{"id": 2,"title": "Makan Siang Klien","start": new Date(2025, 5, 18, 13, 0),"end": new Date(2025, 5, 18, 15, 0),"color": "#EA4335" },
  			{"id": 3,"title": "Presentasi Proyek 1","start": new Date(2025, 5, 18, 15, 0),"end": new Date(2025, 5, 18, 18, 0),"color": "#34A853"},
  			{"id": 4,"title": "Presentasi Proyek 2","start": new Date(2025, 5, 19, 9, 0),"end": new Date(2025, 5, 19, 10, 0),"color": "#D4A853"},
  			{"id": 5,"title": "Presentasi Proyek 3","start": new Date(2025, 5, 20, 9, 0),"end": new Date(2025, 5, 20, 10, 0),"color": "#A4A853"},
  			{"id": 6,"title": "Presentasi Proyek 4","start": new Date(2025, 6, 17, 9, 0),"end": new Date(2025, 6, 17, 10, 0),"color": "#C4A853"},
  			{"id": 7,"title": "Presentasi Proyek 5","start": new Date(2025, 6, 18, 9, 0),"end": new Date(2025, 6, 18, 10, 0),"color": "#64A853"},
  			]);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_cabangid: vCabangidvalue,
			send_currentdate: UFunc.DbDate(currentDate),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_agendaklinik/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setTglLastload(currentDate===undefined?new Date():currentDate);

				const vTmpArr	= JSON.parse(output_string.datamain || "[]");
				vTmpArr.map(vItems=>{
					vItems.desc = UFunc.br2nl(vItems.deskripsi);
					vItems.start = UFunc.toDatetime(vItems.tgl_start);
					vItems.end = UFunc.toDatetime(vItems.tgl_end);
					vItems.allDay = vItems.status_allday==="YA"?true:false;
					vItems.deskripsi = undefined;
					vItems.tgl_start = undefined;
					vItems.tgl_end = undefined;
				});
				setDatamainArr(vTmpArr);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Agendaklinik - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Agendaklinik - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsessimpan = () => {
		const vJamawal	= uDlgformdataObj.status_allday==="YA" ? "00:00" : uDlgformdataObj.jam_awal;
		const vJamakhir	= uDlgformdataObj.status_allday==="YA" ? "23:59" : uDlgformdataObj.jam_akhir;
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,uDlgformdataObj.tabelid);

		const vEltombol	= document.getElementById("btnDialogSimpan");
		vEltombol && (vEltombol.disabled=true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Agendaklinik - apiProsessimpan) LEWAT");
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
			vEltombol && (vEltombol.disabled=true);

			const vDatanewObj	= {
				id:255,
				id_cabang: parseInt(uDlgformdataObj.id_cabang) || uCabangIDinit, 
				title_db: uDlgformdataObj.title,
				title: ((parseInt(uDlgformdataObj.id_dokter)||0) > 0 
					? uDlgformdataObj.caption_dokter+" - "
					: "") + uDlgformdataObj.title,
				start: UFunc.toDatetime(uDlgformdataObj.tgl_awal+" "+vJamawal+":00"),
				end: UFunc.toDatetime(uDlgformdataObj.tgl_akhir+" "+vJamakhir+":00"),
				color: uDlgformdataObj.color,
				allDay: uDlgformdataObj.status_allday==="YA"?true:false,
				status_agenda: uDlgformdataObj?.status_agenda,
				desc: UFunc.br2nl(uDlgformdataObj?.deskripsi),
				id_dokter: parseInt(uDlgformdataObj.id_dokter)||0,
				caption_dokter: uDlgformdataObj.caption_dokter,
				tgl_input: UFunc.DbDatetime(),
				userinput: uTokenObj.usercaption,
			}
			setDatamainArr([...uDatamainArr,vDatanewObj]);

			setDlgformshow(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_datapars: JSON.stringify({
				...uDlgformdataObj,
				dlg_header:undefined,
				jam_awal: vJamawal,
				jam_akhir: vJamakhir,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_agendaklinik/pr_simpan";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){ setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			vEltombol && (vEltombol.disabled=false);
			setLoading(false);
			if(output_string.sukses) {
				const vTabelidnew = parseInt(output_string.tabelid) || (uDlgformdataObj.tabelid || 255);

				const vDatanewObj	= {
					id:vTabelidnew,
					id_cabang: parseInt(uDlgformdataObj.id_cabang) || uCabangIDinit, 
					title_db: uDlgformdataObj.title,
					title: ((parseInt(uDlgformdataObj.id_dokter)||0) > 0 
						? uDlgformdataObj.caption_dokter+" - "
						: "") + uDlgformdataObj.title,
					start: UFunc.toDatetime(uDlgformdataObj.tgl_awal+" "+vJamawal+":00"),
					end: UFunc.toDatetime(uDlgformdataObj.tgl_akhir+" "+vJamakhir+":00"),
					color: uDlgformdataObj.color,
					allDay: uDlgformdataObj.status_allday==="YA"?true:false,
					status_agenda: uDlgformdataObj?.status_agenda,
					desc: UFunc.br2nl(uDlgformdataObj.deskripsi),
					id_dokter: uDlgformdataObj.id_dokter,
					caption_dokter: uDlgformdataObj.caption_dokter,
					tgl_input: vArridx < 0 ? UFunc.DbDatetime() : uDatamainArr[vArridx].tgl_input,
					userinput: vArridx < 0 ? uTokenObj.usercaption : uDatamainArr[vArridx].userinput,
				}

				if(vArridx < 0) {
					setDatamainArr([...uDatamainArr,vDatanewObj]);
					setDlgformdataObj({
						dlg_header: uDlgformdataObj.dlg_header
					});
					showToast(uBahasaObj.pesan_sukses||"Berhasil !","SUKSES");

					if(!uISUpdateallow) {
						setDlgformshow(false); return;
					}

					let vTimeout = setTimeout(()=>{
						clearTimeout(vTimeout);

						const vElfocus = document.getElementById("inptitle");
						if(!isMobile) vElfocus && vElfocus.focus();
					},350);
				}
				else {
					uDatamainArr[vArridx] = vDatanewObj;
					setDlgformshow(false);
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Agendaklinik - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				prosesExpired(); return;
			}
		})
		.catch((error) =>{
			const vTimeEnd = new Date();
			const vTimeDiff = vTimeEnd - vTimeBegin; //in ms

			const vWarnmsg = vTimeDiff >= 40000 ? "<div class='classpetunjuk'>*) Mohon Reset Kalender Anda</div>" : "";

			vEltombol && (vEltombol.disabled=false);
			setLoading(false);

			console.log("(Agendaklinik - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" ")+vWarnmsg,"ERROR");

			if(vTimeDiff >= 40000) {
				setDlgformshow(false);
			}
		});
	}
	const apiProseshapus = () => {
		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,uDlgviewdataObj.tabelid);
		setDlgviewdataObj({...uDlgviewdataObj,is_processing: true});
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Agendaklinik - apiProsessimpan) LEWAT");
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setDlgviewdataObj({...uDlgviewdataObj,is_processing: false});
			setLoading(false);

			uDatamainArr.splice(vArridx,1);
			setDlgviewshow(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid: uDlgviewdataObj.tabelid,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_agendaklinik/pr_hapus";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){ setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setDlgviewdataObj({...uDlgviewdataObj,is_processing: false});
			setLoading(false);
			if(output_string.sukses) {
				uDatamainArr.splice(vArridx,1);
				setDlgviewshow(false);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Agendaklinik - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				prosesExpired(); return;
			}
		})
		.catch((error) =>{
			const vTimeEnd = new Date();
			const vTimeDiff = vTimeEnd - vTimeBegin; //in ms

			const vWarnmsg = vTimeDiff >= 40000 ? "<div class='classpetunjuk'>*) Mohon Reset Kalender Anda</div>" : "";

			setDlgviewdataObj({...uDlgviewdataObj,is_processing: false});
			setLoading(false);

			console.log("(Agendaklinik - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" ")+vWarnmsg,"ERROR");

			if(vTimeDiff >= 40000) {
				setDlgviewshow(false);
			}
		});
	}
	//--END API--/

	React.useEffect(()=>{
		const vElfooter = document.getElementById("idfooter");
		if(!uHtml500msg)
			vElfooter && (vElfooter.style.display = "none");

		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		//--PAGE_LOAD_ALL--/
		apiLoaddokter();
		//--END PAGE_LOAD_ALL--*/

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
    		setDatamainArr([]); setDatadokterArr([]);
			setDlgformshow(false); setDlglookupshow(false);setDlgviewshow(false);
			setTglLastload();setCalendarObj({});
			vElfooter && (vElfooter.style.display = "");
    	}
	},[])
	React.useEffect(()=>{
		if(uCalendarObj?.currentDate === undefined) {
			setCalendarObj({...uCalendarObj,currentDate: new Date()})
		}

		if(uCalendarObj?.currentView === undefined) {
			let vDefaultview;
			switch(uSavedview) {
				case "HARI": 
					vDefaultview = "day";
					break;
				case "MINGGU":
					vDefaultview = "week";
					break;
				case "AGENDA":
					vDefaultview = "agenda";
					break;//*/
				default:
					vDefaultview = "month";
			}
			setCalendarObj({...uCalendarObj,currentView:vDefaultview})
		}//*/

		if(uCalendarObj?.calendarLabel === undefined) {
			setCalendarObj({...uCalendarObj,calendarLabel: ''})
		}
	},[uCalendarObj])
	React.useEffect(()=>{
		if(!uHeaderActionObj.isHeaderReset) return;

		uHeaderActionObj.isHeaderReset  = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setCalendarObj({...uCalendarObj,currentDate:new Date()});
		apiLoaddata();
	},[uHeaderActionObj.isHeaderReset])
	React.useEffect(()=>{
		if(!uHeaderActionObj.isHeaderLoad) return;

		uHeaderActionObj.isHeaderLoad  = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		apiLoaddata();
	},[uHeaderActionObj.isHeaderLoad])
	React.useEffect(()=>{
		if(!uHeaderActionObj.isHeaderView) return;

		const vJenisview				= uHeaderActionObj.initHeaderView || uSavedview;
		uHeaderActionObj.isHeaderView 	= false;
		uHeaderActionObj.initHeaderView = undefined;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		let vValueview;
		let vAgendarange = undefined;
		switch(vJenisview) {
			case "HARI": 
				vValueview = "day";
				break;
			case "MINGGU":
				vValueview = "week";
				break;
			case "AGENDA":
				vValueview = "agenda";
				vAgendarange = {
					start: new Date(),
					end: addMonths(new Date(), 1) // Or your actual agenda range
				}
				break;
			default:
				vValueview = "month";
		}

		setCalendarObj({...uCalendarObj,currentView:vValueview,agendaRange:vAgendarange});
	},[uHeaderActionObj.isHeaderView])
	React.useEffect(()=>{
		if(!uHeaderActionObj.isHeaderNav) return;

		const vJenisview				= uHeaderActionObj.initHeaderView || "TODAY";
		uHeaderActionObj.isHeaderNav 	= false;
		uHeaderActionObj.initHeaderView = undefined;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		initNavigation(vJenisview);
	},[uHeaderActionObj.isHeaderNav])
	React.useEffect(()=>{
		if(!uHeaderActionObj.isHeaderTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

		hdlKlikTambahdata();
	},[uHeaderActionObj.isHeaderTambah])
	React.useEffect(()=>{
		if(!uISDlgformshow) return;

		if(uDlgformdataObj.id_cabang === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				id_cabang: parseInt(uHeaderActionObj.cabang_id) || uCabangIDinit,
			});
			return;
		} 
		if(uDlgformdataObj.tgl_awal === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				tgl_awal: UFunc.DbDate(currentDate),
			});
			return;
		} 
		if(uDlgformdataObj.jam_awal === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				jam_awal: UFunc.JamMenit(currentDate),
			});
			return;
		} 
		if(uDlgformdataObj.tgl_akhir === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				tgl_akhir: UFunc.DbDate(currentDate),
			});
			return;
		} 
		if(uDlgformdataObj.jam_akhir === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				jam_akhir: UFunc.JamMenit(currentDate),
			});
			return;
		} 
		if(uDlgformdataObj.status_allday === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				status_allday: "TIDAK",
			});
			return;
		} 
		if(uDlgformdataObj.status_agenda === undefined) {
			setDlgformdataObj({...uDlgformdataObj,
				status_agenda: "CLOSED",
			});
			return;
		} 
		if(uDlgformdataObj.color === undefined) {
			const vColorIdx = Math.floor(Math.random() * uColoreventArr.length);
			setDlgformdataObj({...uDlgformdataObj,
				color: uColoreventArr[vColorIdx].code||"#ff3d00",
			});
			return;
		} 
	},[uDlgformdataObj.id_cabang,
	uDlgformdataObj.tgl_awal,
	uDlgformdataObj.jam_awal,
	uDlgformdataObj.tgl_akhir,
	uDlgformdataObj.jam_akhir,
	uDlgformdataObj.status_allday,
	uDlgformdataObj.status_allday,
	uDlgformdataObj.status_agenda,
	uDlgformdataObj.color,
	])
	React.useEffect(()=>{
		if(!currentDate) return;
		if(!uTglLastload) return;

		const vTgl1cekDT 			= new Date(uTglLastload.getFullYear(), uTglLastload.getMonth(), 1);

		const vTgl1BulanbeforeDT	= addMonths(vTgl1cekDT, -1);
		const vTgl2BulanafterDT		= addMonths(vTgl1cekDT, 2);
		const vTgl2BulanlastDT		= new Date(vTgl2BulanafterDT.getFullYear(), vTgl2BulanafterDT.getMonth() + 1, 0);
		
		/*console.log("");
		console.log("(Agendaklinik - [currentDate]) currentDate",currentDate);
		console.log("(Agendaklinik - [currentDate]) uTglLastload",uTglLastload);
		console.log("(Agendaklinik - [currentDate]) vTgl1BulanbeforeDT",vTgl1BulanbeforeDT);
		console.log("(Agendaklinik - [currentDate]) vTgl2BulanlastDT",vTgl2BulanlastDT);
		//-*/

		if(currentDate.valueOf() < vTgl1BulanbeforeDT.valueOf() 
			|| currentDate.valueOf() > vTgl2BulanlastDT.valueOf() 
			) apiLoaddata();
	},[currentDate])
	React.useEffect(()=>{
		if(!uISDlgformshow) 
			{ setDlgformdataObj({}); return }

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElfocus = document.getElementById("inptitle");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(!uISDlglookupshow) 
			{ setDlglookupObj({}); return }
	},[uISDlglookupshow])
	React.useEffect(()=>{
		if(!uISDlgviewshow) 
			{ setDlgviewdataObj({}); return }
	},[uISDlgviewshow])

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<strong>{uBahasaObj.caption_page500||"Page 500"}</strong>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)//>

	return (
		<>
		<CCard style={{marginTop:-20,marginBottom:-20}} className="classbgcard">
		<CCardHeader className="py-1 d-flex justify-content-between align-items-center">
		<small>
			<b className="align-middle">
				{calendarLabel || formatCalendarLabel(currentDate, currentView, agendaRange)}
			</b>
		</small>

		<CForm className="d-lg-none">
			<CInputGroup size="sm">
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>initNavigation("PREV")} 
				id="btnBefore">
				<CIcon icon="cilChevronLeft"/>
			</CButton>

			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>initNavigation("TODAY")} 
				id="btnToday">
				<CIcon icon="cilCalendar"/>
			</CButton>
			
			<CButton size="sm" color="light" 
				className="border"
				onClick={()=>initNavigation("NEXT")} 
				id="btnNext">
				<CIcon icon="cilChevronRight"/>
			</CButton>
			</CInputGroup>
		</CForm>

		<span className="d-none d-lg-block text-muted classfontsmaller">
			<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
		</span>
		</CCardHeader>
		
		<CCardBody className="px-0 py-1 px-lg-1" style={{minHeight:350,height:uMaxcardheight}}>
			{contentMain()}
		</CCardBody>
		</CCard>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header||"Lookup Data"}
			inputValue={uDlglookupObj.dlg_input}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"/>

		<MyDialogview
			options={{size:null,centered:true}}
			show={uISDlgviewshow} 
			dialogHeader={uDlgviewdataObj.dlg_header}
			toggle={()=>setDlgviewshow(false)}
			renderContent={contentDlgview()}/>

		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Agendaklinik